<template>
    <div>
        <el-popover popper-class="yushu-share-popover" placement="bottom" width="120" trigger="hover">
            <span slot="reference">
                <slot name="button"></slot>
            </span>
            <ul class="yushu-share-icons clearfix">
                <li>
                    <div>
                        <i class="iconfont iconfont icon-yushuys-share-weixin" @click="generateWeiXinQrCodeImage"></i>
                    </div>
                </li>
                <li>
                    <div>
                        <a :href="createShareUrl('weibo')" target="_blank" alt="分享到新浪微博" title="分享到新浪微博">
                            <i class="iconfont iconfont icon-yushuys-share-weibo"></i>
                        </a>
                    </div>
                </li>
                <li>
                    <div>
                        <a :href="createShareUrl('qq')" target="_blank" alt="分享到QQ空间" title="分享到QQ空间">
                            <i class="iconfont icon-yushuys-share-qq"></i>
                        </a>
                    </div>
                </li>
            </ul>
        </el-popover>
        <el-dialog title="分享到微信" :visible.sync="dlgWeixinQrImageVisible" :close-on-click-modal="false" :append-to-body="true" width="420px">
            <p class="qrImage-wrapper text-center">
                <img :src=" qrcodeImg">
            </p>
            <p class="text-muted text-center mb20">
                <small>打开微信，点击底部的“发现”，<br>使用 “扫一扫” 即可将网页分享到我的朋友圈。</small>
            </p>
        </el-dialog>
    </div>
</template>
<script>
import makeUrl from "@/web-framework/utils/share";
import { Encoder, ErrorCorrectionLevel } from "@nuintun/qrcode";
export default {
    name: 'YushuShare',
    props: ['name', 'content', 'url', 'poster'],
    data() {
        return {
            qrcodeImg: "",              // 微信分享的二维码
            dlgWeixinQrImageVisible: false
        }
    },
    mounted() {
        // 生成几个图标
    },
    methods: {
        // 生成分享链接地址
        createShareUrl(name) {
            let params = {
                title: this.name,
                description: this.content,
                image: this.poster,
                url: this.url
            };
            return makeUrl(name, params);
        },
        // 生成微信二维码图片
        generateWeiXinQrCodeImage() {
            if (this.qrcodeImg.length == 0) {
                let qrcode = new Encoder();
                qrcode.setEncodingHint(true);
                qrcode.setErrorCorrectionLevel(ErrorCorrectionLevel.H);
                qrcode.write(this.url);
                qrcode.make();
                this.qrcodeImg = qrcode.toDataURL(4);
            }

            // 整个页面切换，显示二维码
            this.dlgWeixinQrImageVisible = true;
        },
    }
}
</script>
<style lang="less" scoped>
.yushu-share-icons {
    display: flex;
    justify-content: center;
    li {
        div {
            display: inline-block;
            padding: 0px 10px;
            i {
                font-size: 22px;
                color: #ffffff;
                border-radius: 50%;
                cursor: pointer;
                &.icon-yushuys-share-weixin {
                    &:hover {
                        color: #18df00;
                        background-color: #ffffff;
                    }
                }
                &.icon-yushuys-share-weibo {
                    &:hover {
                        color: #ff6464;
                        background-color: #ffffff;
                    }
                }
                &.icon-yushuys-share-qq {
                    &:hover {
                        color: #2eb5ff;
                        background-color: #ffffff;
                    }
                }
            }
        }
    }
}
.qrImage-wrapper {
    img {
        width: 270px;
        height: 270px;
    }
}
</style>